import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { useTranslation } from 'react-i18next';

type SaveAssetDialogActionsProps = {
  disabled: boolean;
  onSave: () => void;
  onCancel: () => void;
};

export function SaveAssetDialogActions({ disabled, onSave, onCancel }: SaveAssetDialogActionsProps) {
  const { t } = useTranslation();

  return (
    <DialogActions sx={{ padding: '0 1.5rem 1.5rem 1.5rem', gap: '0.5rem' }}>
      <Button variant="text" color="primary" size="medium" onClick={onCancel}>
        {t('library.save_dialog_cancel_button')}
      </Button>
      <Button variant="contained" color="primary" size="medium" disabled={disabled} onClick={onSave}>
        {t('library.save_dialog_save_button')}
      </Button>
    </DialogActions>
  );
}
